import api from "./Api";

class OrdemServicoClienteService {
  GetOrdemServicoCliente(payload) {
    return api.get("/v1/ordemServicoCliente/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServicoCliente(payload) {
    return api.post("/v1/ordemServicoCliente/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServicoCliente(payload) {
    return api.put("/v1/ordemServicoCliente/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServicoCliente(payload) {
    return api.delete("/v1/ordemServicoCliente/" + payload).then((response) => {
      return response.data;
    });
  }

  GetOrdemServicoClienteOData(payload) {
    return api.get("/OData/OrdemServicoCliente" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new OrdemServicoClienteService();
